const PanelFooter = ({ children, ...props }) => {
  return <div className="panel__footer bg-body">{children}</div>;
};

export default PanelFooter;
